import classes from './spacer.module.scss';

function Spacer() {
  return <div className={classes.spacer} />;
}

export default Spacer;
